// Cliente HTTP da Etapa 5. As etapas anteriores não foram alteradas.
import { configureFolhaApiCompleta } from '../etapa3/api'

let config = {
  baseUrl: '/api/v1' /* URL definida por configureFolhaApiEtapa6 (integração FSC) */,
  getHeaders: async () => ({}),
}

export function configureApiEtapa5({ baseUrl, getHeaders } = {}) {
  config = { baseUrl: baseUrl ?? config.baseUrl, getHeaders: getHeaders ?? config.getHeaders }
}

// Configura os clientes das Etapas 1 a 5 de uma vez.
export function configureFolhaApiEtapa5(opcoes = {}) {
  configureFolhaApiCompleta(opcoes)
  configureApiEtapa5(opcoes)
}

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json', ...(await config.getHeaders()) }
  const resp = await fetch(`${config.baseUrl}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const data = await resp.json().catch(() => null)
  if (!resp.ok) {
    const detail = data?.detail
    const msg = Array.isArray(detail) ? detail.map((d) => `${d.loc?.slice(-1)[0] ?? ''}: ${d.msg}`).join('; ') : detail || resp.statusText
    const erro = new Error(msg)
    erro.status = resp.status
    throw erro
  }
  return data
}

const enc = encodeURIComponent

export const apiEtapa5 = {
  funcionarios: (empresaId) => request('GET', `/funcionarios/${enc(empresaId)}`),
  funcionario: (empresaId, id) => request('GET', `/funcionarios/${enc(empresaId)}/${enc(id)}`),
  salvarFuncionario: (empresaId, id, d) => request('PUT', `/funcionarios/${enc(empresaId)}/${enc(id)}`, d),
  complemento: (empresaId) => request('GET', `/empresas/${enc(empresaId)}/complemento`),
  salvarComplemento: (empresaId, d) => request('PUT', `/empresas/${enc(empresaId)}/complemento`, d),
  simularFolha: (e) => request('POST', '/folha-integrada/simular', e),
  calcularFolha: (e) => request('POST', '/folha-integrada/calcular', e),
  enfileirarFolha: (e) => request('POST', '/folha-integrada/lotes', e),
  rescisaoOutrosTipos: (e, gravar) => request('POST', `/rescisao/outros-tipos/calcular?gravar=${gravar ? 'true' : 'false'}`, e),
  sistema: () => request('GET', '/sistema/etapa'),
}
